export default function NewsPulseAbout() {
  return (
    <article className="max-w-3xl mx-auto px-4 lg:px-6 py-10 prose prose-slate" data-testid="newspulse-about">
      <div className="border-b-2 border-slate-900 pb-4 mb-6">
        <div className="text-xs uppercase tracking-widest text-slate-500">Editorial Policy</div>
        <h1 className="text-4xl font-bold text-slate-900">About TheNewsPulse</h1>
      </div>

      <p className="text-lg leading-relaxed text-slate-800">
        TheNewsPulse is the central news intelligence and distribution
        infrastructure for the SocialPulse network. Its role is not to be
        another aggregator, but to be the layer at which the network
        <em> understands</em> the world's news — collect once, understand
        once, distribute everywhere.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-3">How it works</h2>
      <ol className="list-decimal ml-6 space-y-2 text-slate-800">
        <li>Approved sources (governments, regulators, established publishers, universities) are read continuously via RSS, Atom, sitemap and API.</li>
        <li>Every article is normalized, deduplicated, and classified against a canonical taxonomy.</li>
        <li>Related coverage is clustered into one canonical <em>news event</em> with attributions to every reporting source.</li>
        <li>Each event is scored for confidence, importance, and relevance to each destination site.</li>
        <li>Events flow to sister sites (AirlinesAirports, FarmersPulse, TravelerPulse, NaturePulse, FoodPulse, Indias.com, and geographic portals) through a single canonical API. No duplicate scrapers on any site.</li>
      </ol>

      <h2 className="text-xl font-bold mt-8 mb-3">What we don't do</h2>
      <ul className="list-disc ml-6 space-y-2 text-slate-800">
        <li>We do not republish full articles. We link to original reporting. Publishers get the traffic.</li>
        <li>We do not fabricate facts. When unknown, we say unknown.</li>
        <li>We do not auto-publish sensitive events (fatalities, accidents, criminal allegations, election calls, security incidents, medical claims). Those go to human editorial review.</li>
        <li>We do not treat popularity as credibility. Government agencies and primary sources outrank secondary reporting.</li>
      </ul>

      <h2 className="text-xl font-bold mt-8 mb-3">Corrections & attribution</h2>
      <p className="text-slate-800">
        Every event carries every source it was built from. Corrections
        propagate through the network — one canonical event, one canonical
        correction, visible on every site that received the original story.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-3">For publishers</h2>
      <p className="text-slate-800">
        If your organization would like to claim your source profile,
        submit a feed, or discuss licensed syndication, please contact
        the network editor at <a href="mailto:hello@thenewspulse.pro" className="text-blue-900 hover:underline">hello@thenewspulse.pro</a>.
      </p>
    </article>
  );
}
